import { Component, OnInit } from '@angular/core';
import { MainService } from '../../services/main-service.service';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { ProposalService } from 'src/app/services/proposal/proposal.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  settingsData: any;
  date: any = new Date();
  patientData:any;
  modalRef: BsModalRef;
  planInfo: any = {
    patient_first_name: '',
    patient_last_name: '',
    patient_address: '',
    patient_email: '',
    patient_mobile: '',
    zip: '',
    message: ''
  };
  constructor(public mainService: MainService, public proposal: ProposalService) { }

  ngOnInit() {
    this.proposal.getPaymentData().subscribe((data: any) => {
      this.planInfo = data;
    })
    this.proposal.getData().subscribe((data: any) => {
      if (data.split_request_data) {
        this.planInfo = data.split_request_data[0];
      } else if (data && data.result && data.result.patient_email){
        this.planInfo = data.result;
      }
    })
  }

}
